<template>
    <span class="text-color--secondary margin-bottom-10">{{ monthTitle }}</span>
</template>

<script>
    import Translator from 'tools/trans';

    const LOCALE = window.stGlobals.locale;

    export default {
        props: {
            monthName: {
                type: String,
                required: true,
            },
            showMonthly: {
                type: Boolean,
                default: false,
            },
            upcomingReleases: {
                type: Object,
                default: () => undefined,
            },
        },
        data() {
            return {
                locale: LOCALE,
            };
        },
        computed: {
            localeEnDe() {
                if (this.locale === 'en' || this.locale === 'fr' || this.locale === 'es') {
                    return 'en';
                }

                return 'de';
            },
            monthTitle() {
                if (this.monthName === 'past') {
                    return Translator.trans('SMI_RELEASE_LAST_30_DAYS');
                } else {
                    if (this.showMonthly) {
                        return this.upcomingReleases[this.monthName][0].toLocaleDateString(this.localeEnDe, { month: 'long' });
                    } else {
                        return `${ Translator.trans('GLOBAL_WEEK_NUMBER_SHORT') } ${ this.getWeekNumber(this.upcomingReleases[this.monthName][1]) }`;
                    }
                }
            },
        },
        methods: {
            getWeekNumber(date) {
                date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
                date.setUTCDate(date.getUTCDate() + 4 - (date.getUTCDay()||7));
                const yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));

                return Math.ceil((((date - yearStart) / 86400000) + 1)/7);
            },
        },
    };
</script>
